import axios from 'axios';

export const getUserDefaultCountry = setUserCountry => {
  const apiUrl =
    process.env.REACT_APP_APP_ENV_MODE !== 'production'
      ? 'https://api-dev.dojah.services/api/v1/ip'
      : 'https://api.dojah.io/api/v1/ip';
  axios
    .get(apiUrl)
    .then(res => setUserCountry(res.data || 'NG'))
    .catch(() => 'NG');
};
